module.exports = __webpack_public_path__ + "img/img-btnBg.52750711.png";